export default __webpack_public_path__ + "static/e-ferry-efc7609ed1e1d217c586a73036dff9b5.jpg";